import React, { useState } from "react";
import "./write-review.scss";
import { Modal, Button, Form, Input } from "antd";
import { logger } from "../../../../../constant/winston";
import { Http } from "../../../../../helpers/axois";

import { ReactComponent as CloseIcon } from "../../../../../assets/svg/roundedCloseIcon.svg";
import { ReactComponent as StartOutline } from "../../../../../assets/svg/star-outline.svg";
import { ReactComponent as StartBlue } from "../../../../../assets/svg/star-outline-blue.svg";
import { ReactComponent as ReviewFailed } from "../../../../../assets/svg/reviewerror.svg";
import { ReactComponent as ReviewSuccess } from "../../../../../assets/svg/reviewsuccess.svg";
import { useToast } from "../../../../../helpers/commonFunction";
import { useSelector } from "react-redux";
import { AppState } from "../../../../../stateManager/store";
const { TextArea } = Input;

export const WriteReview: React.FC<any> = ({
  visible,
  setVisible,
  currentUser,
  reviews,
  selectedOrg,
  productId,
  getProductPreview,
  getProductReview,
  is_installed,
}): JSX.Element => {
  const [reviewed, setReviewed] = useState(false)
  const [userRating] = reviews.filter((el: any) => (el.reviewed_by.id === currentUser))
  const [data, setData] = useState<any>({
    rating: userRating ? userRating.rating : 0,
    review: userRating ? userRating.review : "",
    title: userRating ? userRating.title : "",
  })
  const  org = useSelector((state: AppState) => state.org.selectedOrg)
  const {ErrorToast}=useToast();
  const orgPermissions: any = useSelector((state: any) => {
    return state.org.orgPermissions
  }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))
  const loggedInUserId = useSelector((state: any) => {
      return state.user.data.user.id
  })

  const addRating = async (data: any) => {
    if ((!orgPermissions?.includes("marketplace.PublishWidget") || !orgPermissions.includes('org.View'))&& loggedInUserId!=org?.owner) {
      ErrorToast("Not Authorized: Please request owner of this organization to provide access")
      return
    } 
    Http.post(
      `/orgs/${selectedOrg}/store/products/${productId}/review`,
      data
    ).subscribe((_refresh) => {
      getProductPreview();
      getProductReview();
      setReviewed(true)
    }, (error) => {
      if (error === "Forbidden") {
        ErrorToast("Not Authorized: Please request owner of this organization to provide access")
      }
      logger.error(error)
      setReviewed(false)
    })
  }
  const updateRating = (data: any) => {
    if ((!orgPermissions?.includes("marketplace.PublishWidget") || !orgPermissions.includes('org.View')) && loggedInUserId!=org?.owner) {
      ErrorToast("Not Authorized: Please request owner of this organization to provide access")
      return
    } 
    const reviewId = userRating.id
    Http.put(
      `/orgs/${selectedOrg}/store/products/${productId}/review/${reviewId}`,
      data
    ).subscribe((_refresh) => {
      getProductPreview();
      getProductReview();
      setReviewed(true)
    }, (error) => {
      if (error === "Forbidden") {
        ErrorToast("Not Authorized: Please request owner of this organization to provide access")
      }
      logger.error(error)
      setReviewed(false)
    })
  };

  const handleChange = (e: any) => {
    const { id, value } = e.target
    setData({ ...data, [id]: value })
  }

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (is_installed) {
      if (userRating) {
        updateRating(data)
      } else {
        if (data?.rating) {
          addRating(data);
        } else {
          ErrorToast("Rating is mandatory");
        }
      }
    }
  }
  const handleOnCancel = (): void => {
    setVisible(false);
  };

  return (
    <>
      {!reviewed ?
        <Modal
          title="WRITE A REVIEW"
          visible={visible}
          maskClosable={false}
          className="override-modal"
          style={{
            top: 200,
          }}
          width="700px"
          closeIcon={
            <CloseIcon
              data-test-id="close_icon"
              height="18px"
              width="18px"
              onClick={() => setVisible(false)}
            />
          }
          footer={[
            <div className="review-footer" key="">
              <Button type="default" className="cancel" onClick={handleOnCancel}>
                Cancel
              </Button>
              <Button type="primary" className="submit" onClick={handleSubmit}>
                Submit
              </Button>
            </div>,
          ]}
          maskStyle={{
            background: "#0000001",
          }}
        >
          <div className="review-modal">
            <p className="review-title">Ratings</p>
            <div className="leave-rating">
              {[...Array(5)].map((_star, index) => {
                const ratingValue = index + 1;
                return (
                  <label htmlFor="rating" key={index}>
                    <input
                      data-test-id="rating"
                      id="rating"
                      type="radio"
                      name="rating"
                      value={ratingValue}
                      disabled={!is_installed}
                      onChange={handleChange}
                    />
                    {ratingValue <= data.rating ? (
                      <StartBlue fill="#1D7AFF" />
                    ) : (
                      <StartOutline />
                    )}
                  </label>
                );
              })}
            </div>
            <Form.Item className="review-title" label={<span>Title</span>}>
              <Input
                placeholder="Enter Title"
                type="text"
                name="title"
                value={data.title}
                id="title"
                onChange={handleChange}
                required
              />
            </Form.Item>
            <Form.Item className="review-title" label={<span>Review (optional)</span>}>
              <TextArea
                className="review-header"
                placeholder="Enter Review"
                name="review"
                rows={5}
                value={data.review}
                id="review"
                onChange={handleChange}
              />
            </Form.Item>
          </div>
        </Modal>
        :
        <Modal
          className="review-message"
          visible={reviewed}
          maskClosable={false}
          style={{
            top: 300,
          }}
          closable={false}
          width="478px"
          footer={false}
        >
          <div className="review-toast">
            {reviewed ?
              <>
                <div>
                  <ReviewSuccess />
                  <h5>You have submitted your review Successfully!</h5>
                </div>
                <div>
                  <Button type="primary" className="submit" onClick={() => setVisible(false)}>
                    Done
                  </Button>
                </div>
              </>
              :
              <div>
                <div>
                  <ReviewFailed />
                  <h5>Failed to submit your review</h5>
                  <div>
                    <Button type="primary" className="submit" onClick={() => setVisible(false)} style={{marginTop:"45px"}}>
                      Please Try Again
                    </Button>
                  </div>
                </div>
              </div>
            }
          </div>
        </Modal>
      }
    </>
  );
};
